<div class="container main-container">
    <h3 class="page-title">Create token / Payment</h3>
    <p>
        {{paymentText}}
    </p>
</div>